export type ThemePreference = 'light' | 'dark' | 'system';

const THEME_KEY = 'fixflow_theme';

export function getStoredTheme(): ThemePreference {
  const raw = localStorage.getItem(THEME_KEY);
  if (raw === 'light' || raw === 'dark' || raw === 'system') return raw;
  return 'light';
}

export function applyTheme(theme: ThemePreference): void {
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else if (theme === 'light') {
    root.classList.remove('dark');
  } else {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    root.classList.toggle('dark', prefersDark);
  }
  localStorage.setItem(THEME_KEY, theme);
}

/** Keep system theme in sync when preference is `system`. */
export function watchSystemTheme(theme: ThemePreference): () => void {
  if (theme !== 'system') return () => undefined;
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const handler = () => applyTheme('system');
  mq.addEventListener('change', handler);
  return () => mq.removeEventListener('change', handler);
}

export function initThemeFromStorage(): void {
  applyTheme(getStoredTheme());
}

/** Avatar color from name — stable hash into brand palette */
export function avatarColorFromName(name: string): string {
  const colors = ['#1B4F8A', '#E8793A', '#10B981', '#8B5CF6', '#EC4899', '#F59E0B'];
  const seed = name.trim() || '?';
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash + seed.charCodeAt(i) * (i + 1)) % 997;
  return colors[hash % colors.length]!;
}

export function initialsFromName(firstName?: string | null, lastName?: string | null): string {
  const a = (firstName ?? '').trim().charAt(0);
  const b = (lastName ?? '').trim().charAt(0);
  const out = `${a}${b}`.toUpperCase();
  return out || '?';
}
